
// SVG Icon: play
export default { id: "terriajs-play" };
export const id = "terriajs-play";
export const name = "play";
